// src/actions/gallery_actions.js
import { fetchGallery, fetchGalleryForPath, slugify } from "../util/gallery_api_util";

/** Action types */
export const REQUEST_MEDIA = "gallery/REQUEST_MEDIA";
export const RECEIVE_MEDIA_SUCCESS = "gallery/RECEIVE_MEDIA_SUCCESS";
export const RECEIVE_MEDIA_FAILURE = "gallery/RECEIVE_MEDIA_FAILURE";

/** Action creators */
export const requestMedia = (key) => ({ type: REQUEST_MEDIA, key });
export const receiveMediaSuccess = (key, items) => ({
  type: RECEIVE_MEDIA_SUCCESS,
  key,
  items,
  receivedAt: Date.now(),
});
export const receiveMediaFailure = (key, error) => ({
  type: RECEIVE_MEDIA_FAILURE,
  key,
  error: error?.message || String(error),
});

/** Key helper for caching/debug */
const keyFromSlugs = ({ continent, country }) =>
  `${slugify(continent || "")}${country ? `/${slugify(country)}` : ""}`;

/** Thunk: fetch by explicit slugs */
export const fetchMediaBySlugs = ({ continent, country = null }) => async (dispatch) => {
  const key = keyFromSlugs({ continent, country });
  dispatch(requestMedia(key));
  try {
    const data = await fetchGallery({ continent, country });
    dispatch(receiveMediaSuccess(key, Array.isArray(data?.items) ? data.items : []));
  } catch (err) {
    dispatch(receiveMediaFailure(key, err));
  }
};

/** Thunk: fetch based on current pathname (e.g. "/africa/madagascar-wildlife") */
export const fetchMediaForPath = (pathname) => async (dispatch) => {
  const data = await fetchGalleryForPath(pathname); // throws on failure
  const { continent, country } = (() => {
    // Recreate what util parsed so our key is consistent
    const parts = String(pathname).replace(/^\/+|\/+$/g, "").split("/");
    return { continent: parts[0] || "", country: parts[1] || null };
  })();
  const key = keyFromSlugs({ continent, country });
  dispatch(requestMedia(key));
  try {
    dispatch(receiveMediaSuccess(key, Array.isArray(data?.items) ? data.items : []));
  } catch (err) {
    dispatch(receiveMediaFailure(key, err));
  }
};
